module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"new_board":"New board name","create":"Create new board","cancel":"Cancel"},"th":{"new_board":"ชื่อบอร์ดใหม่","create":"สร้างบอร์ดใหม่","cancel":"ยกเลิก"}}')
  delete Component.options._Ctor
}
